/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
    },
    getters: {
        defauleSearchSchema:(state)=>{
            return state.defauleSearchSchema;
        }
    },
    mutations: {
        // 设置保存搜索方案
        setSavedSearchSchemas(state, newValue) {
            if(Array.isArray(newValue)) {
                console.log(newValue);
                Vue.set(state, 'savedSearchSchemas', [...newValue]);
            }  
        },
    },
    actions: {
        async folderList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.get(ApiUrl.folder.list,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async folderSet({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.get(ApiUrl.folder.setting,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async newFolder({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.folder.new, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async newFolder1({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.folder.new, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async newFolderChild({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.folder.newChild, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async delFolder({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.delete(ApiUrl.folder.del, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async delMulFolder({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.delete(ApiUrl.folder.batchdel, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async editFolder({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.folder.edit, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}